export default __webpack_public_path__ + "static/media/02d.e381ac12.png";